import { Component, Input, OnInit } from '@angular/core';
import { ProjectItem } from 'src/app/shared/models/base.models';

@Component({
  selector: 'app-space-item-popover',
  templateUrl: './space-item-popover.component.html',
  styleUrls: ['./space-item-popover.component.css']
})
export class SpaceItemPopoverComponent implements OnInit {
  @Input() spaceItem: ProjectItem;

  constructor() { }

  ngOnInit() {
  }

}
